import { render, staticRenderFns } from "./IconGlobe.vue?vue&type=template&id=2d2bd06a&scoped=true&"
import script from "./IconGlobe.vue?vue&type=script&lang=js&"
export * from "./IconGlobe.vue?vue&type=script&lang=js&"
import style0 from "./IconGlobe.vue?vue&type=style&index=0&id=2d2bd06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2bd06a",
  null
  
)

export default component.exports